"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PricingPointKey = void 0;
const types_1 = require("../types");
class PricingPoint {
    constructor({ key, point, rewardAmount, rewardCurrency, }) {
        this.toJSON = () => ({
            key: this.key,
            point: this.point,
            rewardAmount: this.rewardAmount,
            rewardCurrency: this.rewardCurrency,
        });
        this.key = key;
        this.point = point;
        this.rewardAmount = rewardAmount;
        this.rewardCurrency = rewardCurrency;
    }
    static fromJSON(json) {
        const { key, point, rewardAmount, rewardCurrency } = Object.assign({}, json);
        if (!exports.PricingPointKey.includes(key))
            throw new Error('.key must be included in the PricingPointKey.');
        if (typeof point !== 'number')
            throw new Error('.point must be a number');
        if (typeof rewardAmount !== 'number')
            throw new Error('.rewardAmount must be a number');
        if (!Object.values(types_1.Currency).includes(rewardCurrency))
            throw new Error('.rewardCurrency must be included in the Currency.');
        return new PricingPoint({
            key,
            point,
            rewardAmount,
            rewardCurrency,
        });
    }
}
exports.PricingPointKey = ['create', 'resize', 'expressPerDayForCreate', 'expressPerDayForResize'];
exports.default = PricingPoint;
